import React from "react";
import styles from "./apps-card.module.scss";
import Card from ".";
import Button, { BTN_VARIANTS } from "../Button";

import AndroidIcon from "../../assets/icons/android-icon.png";
import IOSIcon from "../../assets/icons/apple-icon.png";
import APKFileFormatIcon from "../../assets/icons/apk-file-format-icon.png";
import V2RayIcon from "../../assets/icons/v2ray-icon.png";
import WireguardIcon from "../../assets/icons/wireguard-icon.png";

const DownloadButtons = ({ details }) => {
  return (
    <section className={styles["download-app"]}>
      {details.android && (
        <Button
          className={styles["download-app-btn"]}
          variant={BTN_VARIANTS.transparent}
          onClick={() => {
            details.android && window.open(details.android);
          }}
        >
          <img src={AndroidIcon} alt="" />
          <span>Android</span>
        </Button>
      )}

      {details.ios && (
        <Button
          className={styles["download-app-btn"]}
          variant={BTN_VARIANTS.transparent}
          onClick={() => {
            details.ios && window.open(details.ios);
          }}
        >
          <img src={IOSIcon} alt="" />
          <span>iOS</span>
        </Button>
      )}

      {details.apk && (
        <Button
          className={styles["download-app-btn"]}
          variant={BTN_VARIANTS.transparent}
          onClick={() => {
            details.folder && window.open(details.folder);
          }}
        >
          <img src={APKFileFormatIcon} alt="" />
          <span>APK</span>
        </Button>
      )}
    </section>
  );
};

const PoweredBy = () => {
  return (
    <section className={styles["powered-by"]}>
      <span className={styles["powered-by-title"]}>Powered by</span>
      <section className={styles["powered-by-powers"]}>
        <section className={styles["powered-by-power"]}>
          <img src={V2RayIcon} alt="" />
          <span>V2Ray</span>
        </section>
        <section className={styles["powered-by-power"]}>
          <img src={WireguardIcon} alt="" />
          <span>Wireguard</span>
        </section>
      </section>
    </section>
  );
};

const AppsCard = ({ data }) => {
  return (
    <Card className={`${styles.root} `}>
      <section className={styles.container}>
        <section
          className={`${styles.left} ${data.isSentinel ? styles.full : ""}`}
        >
          <img src={data.logo} alt="" className={styles.logo} />
          <span className={styles.title}>{data.title}</span>
          <span className={styles.description}>{data.description}</span>
          {data.isSentinel && <DownloadButtons details={data.details} />}
          <Button
            variant={BTN_VARIANTS.primary}
            onClick={() => {
              data.btn.link && window.open(data.btn.link);
            }}
            className={styles.download}
          >
            <span>{data.btn.title}</span>
          </Button>
          {data.isSentinel && <PoweredBy />}
        </section>
        <section className={styles.right}>
          <img src={data.img} alt="" className={styles.img} />
        </section>
      </section>
    </Card>
  );
};

export default AppsCard;
